import { httpClient } from "@/shared/services/http";

export interface IInterviewGuideComposite {
  compositeId: number;
  title: string;
  compositeKey: string;
  interviewQuestionIds: number[];
  positiveIndicators: string[];
  negativeIndicators: string[];
}

export interface IInterviewGuide {
  composites: IInterviewGuideComposite[];
}

export interface ISaveInterviewGuideComposite {
  compositeId: number;
  interviewQuestionIds: number[];
  positiveIndicators: string[];
  negativeIndicators: string[];
}

export class InterviewGuideHttpService {
  static async getInterviewGuide(templateId: number): Promise<IInterviewGuide> {
    const { data } = await httpClient.get<IInterviewGuide>(`/api/assessment-templates/${templateId}/interview-guide`);
    return data;
  }

  static async saveInterviewGuide(templateId: number, composites: ISaveInterviewGuideComposite[]): Promise<void> {
    await httpClient.put(`/api/assessment-templates/${templateId}/interview-guide`, { composites });
  }
}
